import React, { useState, useRef, useEffect } from 'react';

const LazyImage = ({ src, alt, className, ...props }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const imgRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setImageSrc(src);
                    if (entry.target) {
                        observer.unobserve(entry.target);
                    }
                }
            },
            {
                rootMargin: '100px 0px',
            }
        );

        const currentImgRef = imgRef.current;
        if (currentImgRef) {
            observer.observe(currentImgRef);
        }

        return () => {
            if (currentImgRef) {
                observer.unobserve(currentImgRef);
            }
        };
    }, [src]);

    return (
        <img
            ref={imgRef}
            alt={alt}
            className={className}
            {...props}
            {...(imageSrc && { src: imageSrc })}
        />
    );
};

export default LazyImage;
